import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAxios } from 'context/AxiosContextProvider';

import config from '../../config';

export interface useDeleteSupportUserMutationArguments {
  id: number;
}
export default function useDeleteSupportUserMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (supportUserId: useDeleteSupportUserMutationArguments) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/workshop-user/${supportUserId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
